import { AppConstants } from './../../../app.constants';
import { RequestType } from './../../../api/services/base.service';
import { BaseComponent } from './../../../layout/main/base.component';
import { Component, OnInit, HostListener, ElementRef, TemplateRef, ViewChild, AfterViewInit, OnDestroy, AfterViewChecked } from '@angular/core';

import {
  Appointment,
  ComputeOrderBindingModel, ComputeOrderViewModel,
  GiftVoucherOptionType, InvoiceDetailType, Item, ItemCode, Payment, PaymentTypeGroup,
  PlaceOrderBindingModel, PlaceOrderViewModel, ProcessStatus, SendTransactionToEmailBindingModel
} from 'src/app/api/models/web-booking.models';
import { BsModalRef } from 'ngx-bootstrap/modal';

declare let paypal: any;

@Component({
  selector: 'app-service-confirmation',
  templateUrl: './service-confirmation.component.html',
  styleUrls: ['./service-confirmation.component.css']
})

export class ServiceConfirmationComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {

  show = false;

  public preferredDateAndTime: any;
  public giftVoucherNumber = '';
  public appointment: any;
  public therapist: any;
  public appointments: any[];
  public selectedService: ItemCode;

  public mask = '';
  public showGiftVoucherInput = false;
  public message = '';

  public confirmText = 'Yes';
  public showNoButton = false;
  public continueWithNoVoucher = false;
  public voucherOustandingBalance = 0;
  public isFailedToHoldTheGiftVoucher = false;
  public showPayPal = true;

  public disableCancellation = false;
  public isPassSeven = false;
  public monitoringCounter = 0;

  @ViewChild('gvCode') gvCodeField: ElementRef;

  public acceptTerms: boolean;

  public modalGvInput: BsModalRef;
  @ViewChild('tplGvInput') tplGvInput: TemplateRef<any>;

  public modalGvReenterNumber: BsModalRef;
  @ViewChild('tplReEnterMessage') tplReEnterMessage: TemplateRef<any>;

  // Card Details
  public computedOrder: ComputeOrderViewModel;
  // public pendingTransaction: PlaceOrderViewModel = new PlaceOrderViewModel();
  public order: PlaceOrderViewModel;

  // Call cancel transaction when user click back button of the browser
  @HostListener('window:popstate') onPopState(): boolean {
    if (this.disableCancellation) {
      alert('We are processing your transaction, please wait.');
      return false;
    } else {
      this.app.router.navigate([AppConstants.BookingSelectedTreatment]);
      this.cancelPendingTransaction();
      return true;
    }
  }

  ngOnInit(): void {
    this.app.storageService.removeItem(AppConstants.BookingResultFailedToHoldGv);
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.show();
      this.mask = this.app.config.digitalGlueVoucherPattern;

      // Check Selected Items
      this.therapist = JSON.parse(this.app.storageService.getItem(AppConstants.SelectedPractitioner));
      if (this.app.stringService.isEmpty(this.therapist)) {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectedTreatment.toString());
        this.showErrorMessage('Please select a Practitioner');
        this.app.router.navigate([AppConstants.RouteSelectPractitioner]);
        return;
      }

      // Check Selected Items
      this.selectedService = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment));
      if (this.app.stringService.isEmpty(this.selectedService)) {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
        this.showErrorMessage('Please select a treatment');
        this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        return;
      }

      // Check Selected Slot
      const tmpPreferredDateAndTime = this.app.storageService.getItem(AppConstants.BookingSelectedTime);
      if (this.app.stringService.isEmpty(tmpPreferredDateAndTime)) {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
        this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        return;
      }
      this.preferredDateAndTime = JSON.parse(tmpPreferredDateAndTime);

      // Pass Seven Functionality
      const selectedDate = this.app.dateService.getNewDate(this.preferredDateAndTime.time);
      this.isPassSeven = selectedDate.getHours() >= 19;

      // Appointment
      const tmpAppointment = this.app.storageService.getItem(AppConstants.Appointment);
      if (this.app.stringService.isEmpty(tmpAppointment)) {
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
        this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        return;
      }
      this.appointments = JSON.parse(tmpAppointment);
      this.appointment = this.appointments[0];

      // Check Booking Status
      this.getTreatment();
    });

    this.start();
  }

  ngOnDestroy(): void {
    this.removeRefreshEvent();
  } 

  addRefreshEvent(): void {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'F5') {
        alert('We are processing your transaction, please wait.');
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  removeRefreshEvent(): void {
    window.removeEventListener('keydown', (event) => { });
    window.removeEventListener
  }


  getTreatment(): void {
    const m = {
      treatmentId: this.selectedService.treatmentId,
      staffId: this.preferredDateAndTime.slots[0].staffId,
      customerId: this.app.customer.customerId
    };
    this.app.spinner.show();
    this.app.webBookingService.GetTreatment(m)
      .subscribe(
        data => {
          this.selectedService = data;
          this.getTransactionProcessStatus();
        },
        error => {
          this.showErrorMessage(error);
          this.app.spinner.hide();
        });
  }

  getTransactionProcessStatus(): void {
    const cacheTransaction = this.app.storageService.getItem(AppConstants.PendingTransaction);
    if (this.app.stringService.isEmpty(cacheTransaction)) {
      this.computeOrder();
      return;
    }

    this.app.loadingDescription = 'Please wait while checking your booking status...';
    const pendingTransaction = JSON.parse(cacheTransaction) as PlaceOrderViewModel;
    const m = { pendingTransactionId: pendingTransaction.pendingTransactionId };
    this.app.webBookingService.GetTransactionProcessStatus(m)
      .subscribe(data => {
        this.monitoringCounter++;
        if (data === 1) {
          this.disableCancellation = true;
          if (this.monitoringCounter > 5) {
            this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
            this.disableCancellation = false;
            this.order = pendingTransaction;
            this.createPayPalButton();
            this.app.spinner.hide();
            return;
          }
          setTimeout(() => { this.getTransactionProcessStatus(); }, 1000);
        }
        else if (data === 3) {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
          this.app.storageService.removeItem(AppConstants.PendingTransaction);
          this.showErrorMessage('Your transaction has been cancelled. Please try again.');
          this.app.router.navigate([AppConstants.RouteSelectDate]);
        }
        else if (data === 7 || data === 5 || data === 6) {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
          this.app.storageService.removeItem(AppConstants.PendingTransaction);
          this.showErrorMessage('Your transaction is invalid, please wait while refreshing your transaction...');
          setTimeout(() => { window.location.reload(); }, 1000);
        }
        else if (data === 4) {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());
          this.app.storageService.removeItem(AppConstants.PendingTransaction);
          this.app.storageService.setItem(AppConstants.AppointmentResult, JSON.stringify(this.appointment));
          this.app.router.navigate([AppConstants.RouteThankYou]);
        }
        else if (data === 8) {
          this.disableCancellation = true;
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
          if (this.monitoringCounter > 10) {
            this.disableCancellation = true;
            const commitPaymentBindingModel = {
              customerId: this.app.customer.customerId,
              onlinePaymentTransactionId: pendingTransaction.onlineOrderId,
              pendingTransactionId: pendingTransaction.pendingTransactionId,
            };
            this.app.webBookingService.CommitPayment(commitPaymentBindingModel).subscribe(
              () => {
                this.saveAppointmentResult();
                // Send Transaction to email.
                const model = new SendTransactionToEmailBindingModel();
                model.customerId = this.app.customer.customerId;
                model.pendingTransactionId = pendingTransaction.pendingTransactionId;
                model.token = JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token,
                  this.app.webBookingService.SendTransactionToEmail(model).subscribe(
                    () => {
                      this.app.spinner.hide();
                      this.app.router.navigate([AppConstants.RouteThankYou]);
                    },
                    error => {
                      this.showErrorMessage(error);
                      this.app.spinner.hide();
                    }
                  );
              },
              error => {
                this.showErrorMessage(error);
                this.app.spinner.hide();
              }
            );
            return;
          }
          setTimeout(() => { this.getTransactionProcessStatus(); }, 1000);
        }
        else if (data === 2) {
          this.disableCancellation = true;
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
          if (this.monitoringCounter > 10) {
            this.disableCancellation = true;
            this.app.spinner.hide();
            this.app.storageService.removeItem(AppConstants.PendingTransaction);
            this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
            this.app.router.navigate([AppConstants.RouteSelectDate]);
            return;
          }
          setTimeout(() => { this.getTransactionProcessStatus(); }, 1000);
        }
      }, error => {
        this.app.storageService.removeItem(AppConstants.PendingTransaction);
        this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
        this.app.spinner.hide();
        this.showErrorMessage(error);
        this.back();
      });
  }

  openModal(template: TemplateRef<any>): BsModalRef {
    return this.app.modalService.show(
      template,
      {
        class: 'modal-md modal-dialog-centered modal-dialog-scrollable',
        // ignoreBackdropClick: true,
        // keyboard: false
      }
    );
  }

  openModal1(template: TemplateRef<any>): BsModalRef {
    return this.app.modalService1.show(
      template,
      {
        class: 'modal-md modal-dialog-centered modal-dialog-scrollable',
        ignoreBackdropClick: true,
        keyboard: false
      }
    );
  }

  back(): void {
    this.cancelPendingTransaction();
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.router.navigate([AppConstants.RouteSelectDate]);
  }

  redirectToGiftVoucherRedemption(): void {
    if (this.acceptTerms !== true) {
      this.showErrorMessage('Please accept the Terms of Use to continue.');
      return;
    }
    this.app.router.navigate([AppConstants.RouteGiftVoucherRedemption]);
  }

  showGvInputBox(): void {
    if (this.acceptTerms !== true) {
      this.showErrorMessage('Please accept the Terms of Use to continue.');
      return;
    }
    this.giftVoucherNumber = '';
    this.showGiftVoucherInput = true;
    this.modalGvInput = this.openModal(this.tplGvInput);
  }

  checkGiftVoucher(): void {
    if (this.app.stringService.isEmpty(this.giftVoucherNumber)) {
      this.giftVoucherNumber = '';
      this.showErrorMessage('Please enter gift voucher number.');
      return;
    }

    const m = { branchId: this.app.branch.branchId, giftVoucherNumber: this.app.config.digitalGlueVoucherPrefix + this.giftVoucherNumber };
    this.app.spinner.show();
    this.app.webBookingService.GetGiftVoucherRemaingBalance(m)
      .subscribe(
        data => {
          this.voucherOustandingBalance = data;
          if (data === 0) {
            this.app.spinner.hide();
            this.modalGvInput.hide();
            this.modalGvReenterNumber = this.openModal1(this.tplReEnterMessage);
          }
          else {
            this.app.storageService.removeItem(AppConstants.BookingResultFailedToHoldGv);
            this.confirmAppointment(true);
          }
        },
        error => {
          this.app.spinner.hide();
          this.modalGvInput.hide();
          this.modalGvReenterNumber = this.openModal1(this.tplReEnterMessage);
        });
  }

  hideGiftVoucher(): void {
    this.giftVoucherNumber = '';
    this.showGiftVoucherInput = false;
  }

  cancelAppointment(requestType: RequestType = RequestType.Post): void {
    const m = { appointmentId: this.appointment.appointmentId };
    this.app.webBookingService.CancelAppointment(m, requestType)
      .subscribe(data => { }, error => { });
    this.app.router.navigate([AppConstants.RouteSelectDate]);
  }

  confirmAppointment(withVoucher = false): void {
    if (this.acceptTerms !== true) {
      this.showErrorMessage('Please accept the Terms of Use to continue.');
      return;
    }
    const gvNumber = this.app.config.digitalGlueVoucherPrefix + this.giftVoucherNumber;
    let notes = '';
    if (this.isFailedToHoldTheGiftVoucher) {
      notes = this.app.config.appintmentFailedVoucherNotes.replace('[GiftVoucherNo]', gvNumber);
    }
    else {
      const appintmentVoucherNotes = this.app.config.appintmentVoucherNotes
        .replace('[GiftVoucherNo]', gvNumber)
        .replace('[Price]', this.app.config.currencySymbol + this.selectedService.fee.toFixed(2))
        .replace('[VoucherBalance]', this.app.config.currencySymbol + this.voucherOustandingBalance.toFixed(2))
        .replace('[Price]', this.app.config.currencySymbol + this.selectedService.fee.toFixed(2));
      const appintmentNotSecuredNotes = this.app.config.appintmentNotSecuredNotes.replace('[GiftVoucherNo]', gvNumber);
      notes = withVoucher === false ? appintmentNotSecuredNotes : appintmentVoucherNotes;
    }
    const ids = [];
    for (const appointment of this.appointments) {
      ids.push(appointment.appointmentId);
    }
    const m = {
      appointmentIds: ids,
      branchId: this.app.branch.branchId,
      customerId: this.app.customer.customerId,
      notes,
      token: JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token,
      isSecured: withVoucher,
      externalGiftVoucherNumber: gvNumber,
      holdAmount: this.voucherOustandingBalance
    };
    if (this.modalGvInput != null) { this.modalGvInput.hide(); }
    this.disableCancellation = true;
    this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
    this.addRefreshEvent();
    this.app.spinner.show();
    this.app.webBookingService.ConfirmAppointment(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.getProfile();
          this.app.storageService.setItem(AppConstants.AppointmentResult, JSON.stringify(this.appointment));
          this.app.storageService.setItem(AppConstants.BookingTreatmentResult, JSON.stringify(this.selectedService));
          this.app.storageService.setItem(AppConstants.BookingPractionerResult, JSON.stringify(this.therapist));
          this.app.storageService.setItem(AppConstants.BookingSlotResult,
            this.app.storageService.getItem(AppConstants.BookingSelectedTime));
          this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
          this.app.storageService.removeItem(AppConstants.RedirectState);
          this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
          this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
          this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
          this.app.storageService.removeItem(AppConstants.Appointment);
          this.app.storageService.removeItem(AppConstants.PendingTransaction);
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());
          this.app.router.navigate([AppConstants.RouteThankYou]);
        },
        error => {
          this.app.spinner.hide();
          this.app.router.navigate([AppConstants.RouteSelectDate]);
          this.showErrorMessage(error);
          this.back();
        });
  }

  hideModal(modal: any): void {
    modal.hide();
    this.giftVoucherNumber = '';
  }

  closetplReEnterMessage(): void {
    this.giftVoucherNumber = '';
    this.modalGvReenterNumber.hide();
    this.modalGvInput = this.openModal(this.tplGvInput);
  }

  //#endregion Transaction
  computeOrder(): void {
    const model: ComputeOrderBindingModel = new ComputeOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;

    model.items = new Array<Item>();
    const item: Item = new Item();
    item.giftVoucherOptionType = GiftVoucherOptionType.NotGiftVoucher;
    item.description = this.selectedService.name;
    item.invoiceDetailType = InvoiceDetailType.Service;

    item.staffId = this.preferredDateAndTime.slots[0].staffId;
    item.roomId = this.preferredDateAndTime.slots[0].roomId;
    item.staffName = this.preferredDateAndTime.slots[0].staffName;
    item.bookingDate = this.preferredDateAndTime.slots[0].time;
    item.startTime = this.preferredDateAndTime.slots[0].time;
    item.endTime = this.preferredDateAndTime.slots[0].endTime;
    item.appointmentId = this.appointment.appointmentId;
    item.bookingReference = this.appointment.bookingReference;
    item.customerId = this.app.customer.customerId;

    item.quantity = 1;
    item.itemId = this.selectedService.treatmentId;
    item.fee = this.selectedService.fee;
    model.items.push(item);

    const payment: Payment = new Payment();
    payment.paymentTypeGroupId = PaymentTypeGroup.Web;
    model.payments = new Array<Payment>();
    model.payments.push(payment);

    model.enableDepositRequired = this.app.customer.isNewCustomer || this.app.customer.is2YearLastTransaction;

    this.app.webBookingService.ComputeOrder(model)
      .subscribe(
        data => {
          this.computedOrder = data;
          this.placeOrder();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  placeOrder(): void {
    const model: PlaceOrderBindingModel = new PlaceOrderBindingModel();
    model.branchId = this.app.branch.branchId;
    model.customerId = this.app.customer.customerId;

    model.items = new Array<Item>();
    const item: Item = new Item();
    item.giftVoucherOptionType = GiftVoucherOptionType.NotGiftVoucher;
    item.description = this.selectedService.name;
    item.invoiceDetailType = InvoiceDetailType.Service;

    item.staffId = this.preferredDateAndTime.slots[0].staffId;
    item.roomId = this.preferredDateAndTime.slots[0].roomId;
    item.staffName = this.preferredDateAndTime.slots[0].staffName;
    item.bookingDate = this.preferredDateAndTime.slots[0].time;
    item.startTime = this.preferredDateAndTime.slots[0].time;
    item.endTime = this.preferredDateAndTime.slots[0].endTime;
    item.appointmentId = this.appointment.appointmentId;
    item.bookingReference = this.appointment.bookingReference;
    item.customerId = this.app.customer.customerId;

    item.quantity = 1;
    item.itemId = this.selectedService.treatmentId;
    item.fee = this.selectedService.fee;
    model.items.push(item);

    const payment: Payment = new Payment();
    payment.paymentTypeGroupId = PaymentTypeGroup.Web;
    model.payments = new Array<Payment>();
    model.payments.push(payment);

    model.enableDepositRequired = this.app.customer.isNewCustomer || this.app.customer.is2YearLastTransaction;

    this.app.webBookingService.PlaceOrder(model)
      .subscribe(
        data => {
          this.order = data;
          this.app.storageService.setItem(AppConstants.PendingTransaction, JSON.stringify(data));
          this.createPayPalButton();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
          this.cancelAppointment();
        });
  }
  //#endregion

  //#region Paypal Button
  createPayPalButton(): void {
    let clientId: string;
    if (this.app.config.payPalPaymentMode === 'sandbox') {
      clientId = this.app.config.payPalSandboxCliendId;
    }
    else if (this.app.config.payPalPaymentMode === 'production') {
      clientId = this.app.config.payPalProductionCliendId;
    }
    this.loadExternalScript('https://www.paypal.com/sdk/js?currency=' + this.app.config.payPalCurrencyCode + '&client-id=' + clientId);
  }

  loadExternalScript(scriptUrl: string): any {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    scriptElement.addEventListener('load', () => {
      this.loadPayPalSmartPaymentButton();
    });
    scriptElement.addEventListener('error', (e) => {
      this.showErrorMessage('PayPal online payment loading failed.');
      this.showPayPal = false;
    });
    document.body.appendChild(scriptElement);
    setTimeout(() => {
      this.app.spinner.hide();
    }, 3000);
  }

  loadPayPalSmartPaymentButton(): void {
    paypal.Buttons({
      style: {
        layout: 'horizontal',
      },
      onClick: (data, actions) => {
        if (this.acceptTerms) {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.ConfirmAppointment.toString());
          this.disableCancellation = true;
          this.addRefreshEvent();
          return true;
        }
        else {
          this.showErrorMessage('Please accept the Terms of Use to continue.');
          return false;
        }
      },
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: this.order.onlinePaymentAmountToBePaid
            }
          }]
        });
      },

      onApprove: (data, actions) => {
        // cset trabsaction as paid online
        const setTransactionAsPaidOnlineBindingModel = {
          customerId: this.app.customer.customerId,
          pendingTransactionId: this.order.pendingTransactionId,
          onlinePaymentTransactionId: data.orderID
        };
        this.order.onlineOrderId = data.orderID;
        this.app.storageService.setItem(AppConstants.PendingTransaction, JSON.stringify(this.order));
        this.app.webBookingService.SetTransactionAsPaidOnline(setTransactionAsPaidOnlineBindingModel).subscribe(
          () => {
            // check if appointment is expired.
            this.app.spinner.show();
            const isAppointmentExpiredBindingmodel = {
              appointmentId: this.appointment.appointmentId
            };
            this.app.webBookingService.IsAppointmentExpired(isAppointmentExpiredBindingmodel).subscribe(
              result => {
                if (result) {
                  this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
                  this.app.storageService.removeItem(AppConstants.RedirectState);
                  this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
                  this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
                  this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
                  this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
                  this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
                  this.app.storageService.removeItem(AppConstants.Appointment);
                  this.app.storageService.removeItem(AppConstants.PendingTransaction);
                  this.app.router.navigate([AppConstants.RouteSelectConsultation]);
                }
                else {
                  // proceed paypal payment
                  return actions.order.capture().then(
                    payment => {
                      // Show a success message to your buyer
                      const commitPaymentBindingModel = {
                        customerId: this.app.customer.customerId,
                        onlinePaymentTransactionId: payment.id,
                        pendingTransactionId: this.order.pendingTransactionId,
                      };
                      this.app.webBookingService.CommitPayment(commitPaymentBindingModel).subscribe(
                        () => {
                          this.saveAppointmentResult();
                          // Send Transaction to email.
                          const model = new SendTransactionToEmailBindingModel();
                          model.customerId = this.app.customer.customerId;
                          model.pendingTransactionId = this.order.pendingTransactionId;
                          model.token = JSON.parse(this.app.storageService.getItem(AppConstants.Token)).access_token,
                            this.app.webBookingService.SendTransactionToEmail(model).subscribe(
                              () => {
                                this.getProfile();
                                // this ngzone will fix the warning issue: core.js:3126
                                // Navigation triggered outside Angular zone, did you forget to call 'ngZone.run()'?
                                this.app.ngZone.run(() => {
                                  this.app.router.navigate([AppConstants.RouteThankYou]);
                                });
                                this.app.storageService.removeItem(AppConstants.PendingTransaction);
                                this.app.spinner.hide();
                              },
                              error => {
                                this.showErrorMessage(error);
                                this.app.spinner.hide();
                              }
                            );
                        },
                        error => {
                          this.showErrorMessage(error);
                          this.app.spinner.hide();
                        }
                      );

                    },
                    error => {
                      this.showErrorMessage(error);
                      this.app.spinner.hide();
                      return;
                    });
                }
              },
              error => {
                this.showErrorMessage(error);
                this.app.spinner.hide();
              }
            );

          },
          error => {
            this.cancelPendingTransaction();
            this.showErrorMessage(error);
            this.app.spinner.hide();
          });
      },

      onCancel: (data, actions) => {
        this.isAppointmentExpired();
        return;
      },

      onError: (data, actions) => {
        this.isAppointmentExpired();
        return;
      }
    }).render('#paypal-button-container');
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.checkCustomerData();
        },
        error => {
          this.app.spinner.hide();
          this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        });
  }

  saveAppointmentResult(): void {
    this.app.storageService.setItem(AppConstants.AppointmentResult, JSON.stringify(this.appointment));
    this.app.storageService.setItem(AppConstants.BookingTreatmentResult, JSON.stringify(this.selectedService));
    this.app.storageService.setItem(AppConstants.BookingPractionerResult, JSON.stringify(this.therapist));
    this.app.storageService.setItem(AppConstants.BookingSlotResult,
      this.app.storageService.getItem(AppConstants.BookingSelectedTime));
    this.app.storageService.removeItem(AppConstants.BookingGiftVoucherNumber);
    this.app.storageService.removeItem(AppConstants.RedirectState);
    this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
    this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.storageService.removeItem(AppConstants.PendingTransaction);
    this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.Result.toString());
    this.app.router.navigate([AppConstants.RouteThankYou]);
  }
  //#endregion

  //#region BOOKING PROCESS
  isAppointmentExpired(): void {
    this.app.spinner.show();
    const model = {
      appointmentId: this.appointment.appointmentId
    };
    this.app.webBookingService.IsAppointmentExpired(model).subscribe(
      data => {
        if (data) {
          this.app.storageService.removeItem(AppConstants.PendingTransaction);
          this.app.storageService.removeItem(AppConstants.Appointment);
          this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
          this.app.storageService.removeItem(AppConstants.SelectedPractitioner);
          this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
          this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
          this.app.router.navigate([AppConstants.RouteSelectConsultation]);
        }
        this.app.spinner.hide();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  cancelPendingTransaction(requestType: RequestType = RequestType.Post): void {
    const model = {
      customerId: this.app.customer.customerId,
      pendingTransactionId: this.order.pendingTransactionId,
    };
    this.app.spinner.show();
    this.app.webBookingService.CancelPendingTransaction(model, requestType).subscribe(
      data => {
        if (data) {
        }
      },
      error => {
      }
    );
    this.app.spinner.hide();
    this.app.storageService.removeItem(AppConstants.PendingTransaction);
    this.app.storageService.removeItem(AppConstants.Appointment);
    this.app.router.navigate([AppConstants.RouteSelectDate]);
  }
  //#endregion
}
